import React from "react";

export const CrownIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M4 8.5l3.2 2.8L12 5l4.8 6.3L20 8.5l-1.4 8.5H5.4L4 8.5z"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path d="M6.5 19.5h11" strokeLinecap="round" />
  </svg>
);

export const GiftIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="9.5" width="17" height="4" rx="1" />
    <path d="M5 13.5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7M12 9.5v12" strokeLinejoin="round" />
    <path
      d="M12 9.5c-1.5 0-3.5-.8-3.5-2.8a2 2 0 0 1 4 0c0 .5-.1 1-.5 1.7M12 9.5c1.5 0 3.5-.8 3.5-2.8a2 2 0 0 0-4 0c0 .5.1 1 .5 1.7"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);
